export enum PaymentWrapperAction {
  SET_PAYMENT_WRAPPER_VIEW = "SET_PAYMENT_WRAPPER_VIEW",
  SHOW_PAYMENT_MODES = "SHOW_PAYMENT_MODES",
  SHOW_RESEND_INVOICE_PAYMENT_REQUEST_ACTION = "SHOW_RESEND_INVOICE_PAYMENT_REQUEST_ACTION",
  SHOW_UPDATE_INVOICE_PAYMENT_REQUEST_ACTION = "SHOW_UPDATE_INVOICE_PAYMENT_REQUEST_ACTION",
  SHOW_UPDATE_OFFLINE_PAYMENT_REQUEST_ACTION = "SHOW_UPDATE_OFFLINE_PAYMENT_REQUEST_ACTION",
  SHOW_OFFLINE_PAYMENT_REQUESTED_INFO_ACTION = "SHOW_OFFLINE_PAYMENT_REQUESTED_INFO_ACTION",
  SET_IS_PAYMENT_SYNC_FAILED = "SET_IS_PAYMENT_SYNC_FAILED"
}

export enum PaymentWrapperView {
  NONE = "NONE",
  PAY_BY_SELF = "PAY_BY_SELF",
  REQUEST_PAYMENT = "REQUEST_PAYMENT",
  OFFLINE_PAYMENT = "OFFLINE_PAYMENT",
  OFFLINE_PAYMENT_REQUESTED = "OFFLINE_PAYMENT_REQUESTED"
}
